export class JsonPostQueryHelper{
  static staticInstance: JsonPostQueryHelper = new JsonPostQueryHelper();
  static getInstance(): JsonPostQueryHelper{
    return this.staticInstance;
  }

  static sendRequest(route: string, body: object, requiresStoryline = true){
    return this.getInstance().sendPostRequest(route, body, requiresStoryline);
  }

  static sendRequestNoToken(route: string, body: object){
    return this.getInstance().sendPostRequestNoToken(route, body);
  }

  static setUrlBase(urlBase: string){
    this.getInstance().setUrlBase(urlBase);
  }

  static getUrlBase(): string{
    return this.getInstance().urlBase;
  }

  static setStoryline(storyline: string){
    this.getInstance().setStoryline(storyline);
  }

  static setToken(token: string){
    this.getInstance().setToken(token);
  }

  static getToken(){
    this.getInstance().getToken();
  }


  static setErrorHandler(errorHandler: () => void){
    this.getInstance().setErrorHandler(errorHandler);
  }

  constructor(public urlBase: string = "", public storyline: string = "", public token:string = "", public errorHandler = () => {}){
  }

  setUrlBase(urlBase: string){
    this.urlBase = urlBase;
  }

  setToken(token: string){
    this.token = token;
  }

  getToken(): string{
    return this.token;
  }

  setStoryline(storyline: string){
    this.storyline = storyline;
  }

  setErrorHandler(errorHandler: () => void){
    this.errorHandler = errorHandler;
  }

  sendPostRequestNoToken(route: string, body: Object | null){
    return fetch(this.urlBase + route, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then((response) => response.json()).catch(error => {
      // alert("Request failed - will logout");
      this.errorHandler();
    });
  }

  sendPostRequest(route: string, body: Object | null, requiresStoryline) {
    if(requiresStoryline && (this.storyline == "")){
      alert("No storyline selected - " + route);
      return;
    }

    let bodyWithToken = body!=null?{ token: this.token, storyline: this.storyline, ... body }:{ token: this.token };
    return this.sendPostRequestNoToken(route, bodyWithToken);
  }
}
  